export const isLeapYear = (year) => {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
};

export const getTotalDaysInYear = (year) => {
    return isLeapYear(year) ? 366 : 365;
};

export const getDaysCompletedInYear = (year) => {
    const today = new Date();
    const currentYear = today.getFullYear();

    if (year < currentYear) {
        return getTotalDaysInYear(year);
    }

    if (year > currentYear) {
        return 0;
    }

    const startOfYear = new Date(year, 0, 1);
    const diffTime = today - startOfYear;

    return Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;
};

export const getShortLabel = (name = "") => {
    if (!name) return "";

    const firstLetter = name.trim()[0].toUpperCase();
    const numberMatch = name.match(/\d+/);

    return numberMatch
        ? `${firstLetter}${numberMatch[0]}`
        : firstLetter;
};

export const getFromToDates = ({ filterType, year, dateRange }) => {
    if (filterType === "YEAR") {
        return {
            from: `${year}-01-01`,
            to: `${year}-12-31`,
        };
    }

    if (filterType === "DATE_RANGE") {
        return {
            from: dateRange?.from ?? null,
            to: dateRange?.to ?? null,
        };
    }

    return {
        from: null,
        to: null,
    };
};

export const getElapsedDaysInYear = (year) => {
    const start = new Date(`${year}-01-01`);
    const today = new Date();
    const end =
        today > new Date(`${year}-12-31`)
            ? new Date(`${year}-12-31`)
            : today;

    return Math.floor((end - start) / 86400000) + 1;
};

export const format2 = (value) => {
    if (typeof value === "number") {
        return value.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }
    return "--";
};

export const getYearProgress = (to) => {
    const endDate = new Date(to);
    const year = endDate.getFullYear();
    const startOfYear = new Date(year, 0, 1);
    const elapsedDays = Math.floor((endDate - startOfYear) / 86400000) + 1;
    const totalDays = getTotalDaysInYear(year);
    return { year, elapsedDays, totalDays };
};

export const percent = (actual, target) => {
    if (!target || target <= 0) return "--";
    return `${((actual / target) * 100).toFixed(1)}%`;
};

export const getProRataProgress = (filterType, to, yearParam) => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const queryYear = Number(yearParam) || currentYear;

    let targetDate;

    if (filterType === "YEAR") {
        if (queryYear === currentYear) {
            targetDate = today;
        } else if (queryYear < currentYear) {
            targetDate = new Date(`${queryYear}-12-31`);
        } else {
            targetDate = new Date(`${queryYear}-01-01`);
        }
    } else {
        targetDate = to ? new Date(to) : today;
    }

    const year = targetDate.getFullYear();
    const startOfYear = new Date(year, 0, 1);
    const elapsedDays = Math.floor((targetDate - startOfYear) / 86400000) + 1;
    const totalDays = getTotalDaysInYear(year);

    return { elapsedDays, totalDays };
};